module.exports = "{{$parent.row.sources.length}}"